module.exports = __webpack_public_path__ + "static/media/store-alt.7263cdfc.svg";